var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlocks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24.83 21.73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#1db2d7;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.7,10.58,19,8.83V3.57a1.75,1.75,0,0,0-1.13-1.64L13,.11a1.74,1.74,0,0,0-1.23,0L7,1.93A1.76,1.76,0,0,0,5.81,3.57V8.83L1.13,10.58A1.75,1.75,0,0,0,0,12.22v5.34a1.74,1.74,0,0,0,1,1.56l4.84,2.42a1.74,1.74,0,0,0,1.57,0l5-2.52,5,2.52a1.74,1.74,0,0,0,1.57,0l4.84-2.42a1.74,1.74,0,0,0,1-1.56V12.22A1.75,1.75,0,0,0,23.7,10.58ZM17.36,8.87l-4.12,1.54V7.11l4.12-1.8ZM7.47,3.5l4.94-1.85L17.36,3.5v0l-4.95,2-4.94-2Zm4.07,14.11L7.42,19.68V15.84L11.54,14Zm0-5.43-4.94,2-4.95-2v0L6.6,10.3l4.94,1.85Zm11.64,5.43-4.12,2.07V15.84L23.18,14Zm0-5.43-4.95,2-4.94-2v0l4.94-1.85,4.95,1.85Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlocks);
export default __webpack_public_path__ + "static/media/Blocks.bd5e72683c27e0e8fd5df0198e07929d.svg";
export { ForwardRef as ReactComponent };